import styled from 'styled-components';
import { complementaryColor, fontSize, fontWeight, mediaMax, primaryColor, tertiaryColor } from '@styles/utils';
import CustomLink from '@shared/components/link/CustomLink';

export const DiagnosticsStepsContainer = styled.div``;

export const DiagnosticsStepsContent = styled.div`
  margin: 0 auto;
  padding: 56px 0 64px 0;
  width: 100%;
  max-width: 1090px;

  @media screen and (max-width: 1230px) {
    padding: 40px 16px;
  }

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const DiagnosticsStepsContentTitle = styled.h2`
  ${fontSize.h2};
  font-weight: ${fontWeight.standard};
  color: ${primaryColor(500)};
`;

export const DiagnosticsStepsContentDetail = styled.div`
  padding-top: 40px;

  ol {
    padding: 15px 10px;

    li {
      padding-bottom: 5px;
      padding-left: 43px;
      position: relative;
      list-style: none;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 30px;
        height: 25px;
        color: ${tertiaryColor(700)};
        background-color: ${primaryColor(100)};
        transform: rotate(-10deg) translateX(-5px);
      }

      &:after {
        position: absolute;
        left: 5px;
        top: 0;
        transform: translateY(5px) translateX(1px);
        content: counter(list-item) '';
        ${fontSize.extraSmall};
        font-weight: ${fontWeight.bold};
      }
    }
  }

  .ql-align-center {
    text-align: center;
  }

  @media screen and (max-width: 1230px) {
    padding: 30px 0;
  }
`;

export const DiagnosticsStepsDocumentsContainer = styled.div`
  margin: 0 auto;
  padding: 56px 0 64px 0;
  width: 100%;
  max-width: 1090px;

  @media screen and (max-width: 1230px) {
    padding: 40px 16px;
  }

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const DiagnosticsStepsDocumentsContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;

  @media screen and (max-width: 1230px) {
    grid-template-columns: 1fr;
  }
`;

export const DiagnosticsStepsDocumentsItem = styled.div`
  padding: 8px;
  display: grid;
  grid-template-columns: 1fr 60px;
  background-color: ${complementaryColor('white')};
  align-items: center;
`;

export const DiagnosticsStepsDocumentsText = styled.div`
  padding: 5px 15px 5px 5px;
`;

export const DiagnosticsStepsDocumentsTitle = styled.p`
  ${fontSize.label};
  font-weight: ${fontWeight.standard};
  color: ${tertiaryColor(700)};
  line-height: 1.63;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media screen and (max-width: 1230px) {
    padding-bottom: 0;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
  }
`;

export const DiagnosticsStepsDocumentsDescription = styled.p`
  padding-top: 8px;
  ${fontSize.label};
  font-weight: ${fontWeight.normal};
  color: ${tertiaryColor(700)};
  line-height: 1.81;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DiagnosticsStepsDocumentsImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: solid 1px #cbcbcb;
`;

export const DiagnosticsStepsAnswersContainer = styled.div`
  background-color: ${complementaryColor('white')};

  @media screen and (max-width: 1230px) {
    padding: 0 16px;
  }
`;

export const DiagnosticsStepsAnswersContent = styled.div`
  margin: 0 auto;
  padding: 64px 0 48px 0;
  width: 100%;
  max-width: 1090px;
`;

export const DiagnosticsStepsAnswersContentItems = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const DiagnosticsStepsAnswersLink = styled(CustomLink)`
  margin-bottom: 16px;
  padding: 15px 18px;
  text-decoration: none;
  background-color: ${tertiaryColor(100)};
  border: solid 2px rgba(11, 102, 75, 0.45);
  
  &:not(:last-child) {
    margin-right: 20px;
  }
;)
`;
